export const ADD_MESSAGE = 'ADD_MESSAGE'
export const ADD_FIREWALLD = 'ADD_FIREWALLD'
export const SWAP_DIV = 'SWAP_DIV'

export function addMessage(payload) {
    return {
        type: ADD_MESSAGE, payload
    }
}

export function addFirewallD(payload) {
    return {
        type: ADD_FIREWALLD, payload
    }
}

export function swapDiv() {
    return {
        type: SWAP_DIV
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions.js